import * as JSONSourceMap from "json-source-map";
import { Liquid } from "liquidjs";

export const containsLiquid = (input: string): boolean => {
  return input.includes("{{");
};

export const encodeLiquidURI = (url: string): string => {
  return url.replace(/\r?\n|\r/g, "");
};

export const processLiquidTemplate =
  (
    liquidTemplate: string,
    onSuccess: (result: string) => void,
    onError?: (error: string) => void,
    jsonPayload?: string,
  ): (() => Promise<void>) =>
  async () => {
    try {
      const parsedJson = jsonPayload ? JSON.parse(jsonPayload) : {};
      const engine = new Liquid();
      const tpl = engine.parse(liquidTemplate);
      const result = await engine.render(tpl, parsedJson);
      onSuccess(result);
    } catch (error) {
      console.error(error);
      const errorMessage =
        error instanceof Error
          ? `Error: ${error.message}`
          : "Unknown error occurred.";
      if (onError) {
        onError(errorMessage);
      } else {
        console.error(errorMessage);
      }
    }
  };

export const jsonPathToLiquidPath = (parts: Array<null | string>): string => {
  return parts
    .slice(1) // skip "root"
    .filter((part): part is string => part !== null) // remove null values
    .map((part) => (Number.isInteger(Number(part)) ? `[${part}]` : part)) // put brackets around index
    .join(".") // construct string
    .replace(/\.?\[(\d+)\]/g, (_, idx) => `[${idx}]`); // fix records.1.element
};

export const findJsonPathAtOffset = (
  text: string,
  offset: number,
): null | string[] => {
  const { pointers } = JSONSourceMap.parse(text);

  let closestPath: null | string[] = null;
  let closestDistance = Infinity;

  for (const [path, pos] of Object.entries(pointers)) {
    if (pos.key && Math.abs(pos.key.pos - offset) < closestDistance) {
      closestPath = path.split("/").filter(Boolean);
      closestDistance = Math.abs(pos.key.pos - offset);
    }
    if (pos.value && Math.abs(pos.value.pos - offset) < closestDistance) {
      closestPath = path.split("/").filter(Boolean);
      closestDistance = Math.abs(pos.value.pos - offset);
    }
  }

  return closestPath;
};
